import { createContext, useContext } from 'react';

type ToggleContextProps = {
	isOpen: boolean;
	toggle?: () => void;
};

const ToggleContext = createContext<ToggleContextProps>({ isOpen: false } as ToggleContextProps);

type ToggleProps = {
	children: React.ReactNode;
	isOpen: boolean;
	setIsOpen: (o: boolean) => void;
};

const useProvideToggle = (isOpen: boolean, setIsOpen: (o: boolean) => void) => {
	const toggle = () => setIsOpen(!isOpen);

	return {
		isOpen,
		toggle,
	};
};

const ToggleContextProvider = ({ children, isOpen, setIsOpen }: ToggleProps) => {
	const toggle = useProvideToggle(isOpen, setIsOpen);

	return <ToggleContext.Provider value={toggle}>{children}</ToggleContext.Provider>;
};

export const useToggle = () => useContext(ToggleContext);

export default ToggleContextProvider;
